import Competencies from "@/data/competenciesKnowledgeData"
const state = {
    competencies: [],
};

const mutations = {
    setCompetencies(state, value) {
        state.competencies = value;
    },
};

const actions = {
    fetchCompetencies({ commit }) {
        commit('setCompetencies', Competencies);
    }
};

const getters = {
    competencies: (state) => state.competencies,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
